var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content queryChangeCharge" },
    [
      _c(
        "search-item",
        {
          key: _vm.identify,
          ref: _vm.identify,
          attrs: {
            "show-more-scheme": true,
            "show-simple": true,
            "expand-adv": true,
            "search-item-code": _vm.searchItemCode,
            "config-module": _vm.configModule,
            "auto-init": _vm.searchItemAutoInit,
            "custom-search-items": _vm.customSearchItems,
            "custom-sim-query-placeholder": _vm.simQueryPlaceholder,
            "is-append-query": true
          },
          on: {
            advSearchItemCallBack: _vm.fetchData,
            simSearchItemCallBack: _vm.fetchDataBykeyWord
          }
        },
        [
          _c("template", { slot: "operations" }, [_vm._t("operations")], 2),
          _c(
            "template",
            { slot: "searchAreaHeader" },
            [_vm._t("searchAreaHeader")],
            2
          ),
          _c("template", { slot: "other" }, [_vm._t("other")], 2)
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "section grid-wrapper" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              "config-module": _vm.gridConfigModule,
              "grid-params": _vm.gridParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "pagination-wrapper",
          attrs: { id: "footer-wrapper-tab-change-charge" }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.appendQuery,
                  expression: "appendQuery"
                }
              ],
              staticClass: "pagination-container"
            },
            [
              _c("el-pagination", {
                staticStyle: { "text-align": "left" },
                attrs: { total: _vm.searchConditions.total, layout: "total" }
              })
            ],
            1
          ),
          _c("cargo-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.appendQuery,
                expression: "!appendQuery"
              }
            ],
            ref: "paginationChangeCharge",
            attrs: {
              "config-module": _vm.gridConfigModule,
              total: _vm.searchConditions.total,
              page: _vm.searchConditions.pageNum,
              limit: _vm.searchConditions.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.searchConditions, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.searchConditions, "pageSize", $event)
              },
              pagination: _vm.fetchDataByPage
            }
          })
        ],
        1
      ),
      _vm.workFlowApplyDialog.visible
        ? _c("charge-apply-dialog", {
            attrs: {
              visible: _vm.workFlowApplyDialog.visible,
              "change-charge": _vm.workFlowApplyDialog.changeCharge,
              title: _vm.$t("CargoMsg.Cargo_Approving"),
              "process-info": _vm.workFlowApplyDialog.documentProcess,
              records: _vm.workFlowApplyDialog.approvalCommentsRecords,
              type: "approve"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.workFlowApplyDialog, "visible", $event)
              },
              close: function($event) {
                _vm.workFlowApplyDialog.visible = false
              },
              closeAndRefresh: function() {
                _vm.workFlowApplyDialog.visible = false
                _vm.fetchDataByPage()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }